var shadows = {
  base: '0 0px 12px -8px rgba(0, 0, 0, 0.35)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  none: 'none'
};
export default shadows;